import React from "react";
import NotificationsInbox from "../components/NotificationsInbox";

export default function NotificationsPage() {
  return <NotificationsInbox />;
}
